import { Link } from "react-router-dom";

import thumbnailMap from "../../public/thumbnail-map2.jpg";

function BlogsDesktop() {
  return (
    <section id="blog" className="pt-[80px] mb-[40px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-[24px] font-medium mb-8">Writing</p>
        </div>

        <p className="text-gray-4">
          I occasionally write about programming, productivity, and more.
        </p>
        <p className="text-gray-4 mb-2">1 post so far. Stay tuned for more!</p>

        <a href="/blog/map" className="flex flex-row items-center gap-8">
          <div className="mb-4 w-[500px] 2xl:w-[500px] mr-20">
            <p className="text-sm text-gray-4 ">May 23, 2024</p>
            <p className="mt-2">
              Picking a location with React Native using a performance-oriented
              approach like Grab, Uber, and others do
            </p>
          </div>

          <div className="w-[220px] h-[125px] overflow-hidden rounded-lg mb-6 mt-3">
            <img
              src={thumbnailMap}
              alt="thumbnail"
              className="object-cover w-full h-full"
            />
          </div>
        </a>
      </div>
    </section>
  );
}

export default BlogsDesktop;
